import React from 'react';
import {findDOMNode} from 'react-dom';

export default class ComponentWithClassMethods extends React.Component<any,any> {

    addClass(className:string, ref?:any) {
        const node:any = findDOMNode(ref ? ref : this);

        if (node) {
            node.classList.add(className);
        }
    }

    removeClass(className:string, ref?:any) {
        const node : any = findDOMNode(ref ? ref : this);
        if (node) {
            node.classList.remove(className);
        }
    }

    toggleClass(className:string, value:boolean, ref:any) {
        value ? this.addClass(className, ref) : this.removeClass(className, ref)
    }
}
